module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_angst.aa4205c5.svg";